import { RegisterModule } from '@/typings/common'

import { createMapper, Module, registerModule as vuexRegisterModule } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'
import {
  FormTemplateActions,
  FormTemplateGetters,
  FormTemplateMutations,
  FormTemplateState,
} from '@/views/FormTemplates/store/store'


const storeModule = (
  new Module({
    namespaced: true,
    state: FormTemplateState,
    getters: FormTemplateGetters,
    mutations: FormTemplateMutations,
    actions: FormTemplateActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as FormTemplatesStoreModule,
  mapper as FormTemplatesStoreMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
